/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo } from 'react';
import { CommonActions } from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from 'react-native';
import Toast from 'react-native-toast-message';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import * as Auth from '@/store/auth/actions';
import { setCountryCookieAndRedirect } from '@/store/auth/actions';
import { showPopup } from '@/store/modal';
import {
  changeLanguage,
  SUPPORTED_LANGUAGES,
  VISIBLE_LANGUAGES,
} from '@/store/language';
import Image from '@components/global/Image';
import Photo from '@components/global/Photo';
import SociollaText from '@components/sociolla/SociollaText';
import { Loader } from '@components/screen/Layout';
import ModalFull from '@components/modal/ModalFull';
import SwitcherDropdown from '@components/shared/SwitcherDropdown';
import RadioIcon from '@components/shared/RadioIcon';
import NotificationItem from '@/screens/task-notification/components/NotificationItem';
import { showAlert } from '@/store/global';

import Colors from '@/global/colors';
import { isWeb, isNative, fullHeight, isWebPlatform } from '@global/screens';
import { handleTaskNotificationDetail, isVn } from '@global/helpers';
import { handleNotification } from '@/store/auth/actions';
import { MsB2b } from '@api/ms-b2b';
import { logEvent } from '@global/analytics';
import { SETTING_MENUS } from '@/constants/menus';
import { NET_DOMAIN } from '@/constants';

const photoWidth = 22;

const SettingList = React.memo(
  ({ menus, dispatch, onClickSetting }) => {
    const insets = useSafeAreaInsets();
    const showSetting = useSelector((state) => state.modal.showSetting);

    return isWeb ? (
      <View
        testID="setting-dropdown-wrapper"
        style={[styles.profileDropdown, { height: 458 }]}>
        <ScrollView showsVerticalScrollIndicator={true}>
          {menus.map((item, idx) => (
            <TouchableOpacity
              testID={`setting-item-${item.name
                .toLowerCase()
                .replace(/\s+/g, '-')}`}
              activeOpacity={0.9}
              onPress={() => onClickSetting(item)}
              style={[styles.dropdownItem, styles.dropdownItemBordered]}
              key={idx}>
              <Text style={styles.dropdownText}>{item.name}</Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
    ) : (
      <ModalFull
        testID="setting-modal"
        title="Setting"
        back={true}
        show={showSetting}
        onClose={() =>
          dispatch(showPopup({ name: 'showSetting', value: false }))
        }>
        <ScrollView
          style={{
            width: '100%',
            height: fullHeight - insets.top - insets.bottom,
          }}>
          {menus.map((item, idx) => (
            <TouchableOpacity
              testID={`setting-item-${item.name
                .toLowerCase()
                .replace(/\s+/g, '-')}`}
              activeOpacity={0.9}
              onPress={() => onClickSetting(item)}
              style={{
                width: '100%',
                paddingVertical: 20,
                paddingHorizontal: 15,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottomColor: Colors.grey0,
                borderBottomWidth: 1,
              }}
              key={idx}>
              <SociollaText type="medium">{item.name}</SociollaText>
              <Image
                source={require('@/assets/img/icons/arrow-right-grey.svg')}
                style={{ width: 5, height: 10 }}
                width={5}
                height={10}
                svg={true}
              />
            </TouchableOpacity>
          ))}
        </ScrollView>
      </ModalFull>
    );
  },
  (prev, next) => prev == next,
);

const NotificationList = React.memo(
  ({ loading, data, onDetail, onList }) => {
    return loading ? (
      <Loader />
    ) : data && data.length ? (
      <>
        {data?.slice(0, 3)?.map((item, idx) => (
          <NotificationItem
            key={idx}
            item={item}
            onPress={() => onDetail(item)}
          />
        ))}
        {data?.length > 3 ? (
          <TouchableOpacity
            testID="header-notification-see-more-btn"
            activeOpacity={0.6}
            style={{
              padding: 12,
              flexDirection: 'row',
              justifyContent: 'center',
              borderTopColor: Colors.grey0,
              borderTopWidth: 1,
            }}
            onPress={() => onList()}>
            <SociollaText style={{ fontSize: 12, color: Colors.blue1 }}>
              See More
            </SociollaText>
          </TouchableOpacity>
        ) : (
          false
        )}
      </>
    ) : (
      <View
        style={{
          padding: 20,
          flexDirection: 'row',
          justifyContent: 'center',
        }}>
        <SociollaText>No notification found.</SociollaText>
      </View>
    );
  },
  (prev, next) => prev == next,
);

const NotificationSettingButton = (props) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const showSetting = useSelector((state) => state.modal.showSetting);
  const notificationCount = useSelector(
    (state) => state.auth.notificationCount,
  );
  const menuPermission = useSelector((state) => state.auth.menuPermission);
  const language = useSelector((state) => state.language.selected);
  const [isShowProfileDropdown, setIsShowProfileDropdown] = useState(false);
  const [isShowCountryDropdown, setIsShowCountryDropdown] = useState(false);
  const [isShowLanguageDropdown, setIsShowLanguageDropdown] = useState(false);
  const [isShowNotification, setIsShowNotification] = useState(false);
  const [isLoadingNotification, setIsLoadingNotification] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isVietnam, setIsVietnam] = useState([]);

  const notificationStyle = { ...styles.notificationSetting };
  const defaultSize = isWeb ? 19 : 23;
  const nofiticationSize = { width: defaultSize, height: defaultSize };

  const disableSettingIcon =
    ['3pl'].includes(userData?.role?.code) ||
    (isWebPlatform ? NET_DOMAIN.includes(window.location.hostname) : false);

  // get notification lists
  const getNotificationData = async () => {
    try {
      if (!isLoadingNotification) {
        setIsLoadingNotification(true);
        resetNotificationCount();
        const notif = await MsB2b.getNotifications();
        if (
          notif.status == 200 &&
          notif.data &&
          notif.data.data &&
          notif.data.data.length
        ) {
          setNotifications(notif.data.data);
        } else {
          setNotifications([]);
        }
      }
      setTimeout(() => {
        setIsLoadingNotification(false);
      }, 800);
    } catch (error) {
      setTimeout(() => {
        setIsLoadingNotification(false);
      }, 800);
    }
  };

  const resetNotificationCount = async () => {
    if (notificationCount > 0) {
      const readMessage = await MsB2b.setNotificationReaded();
      if (readMessage?.data?.data) {
        dispatch(handleNotification(0));
      }
    }
  };

  // close all dropdown when change the route
  useEffect(() => {
    return () => {
      setIsShowProfileDropdown(false);
      setIsShowCountryDropdown(false);
      setIsShowLanguageDropdown(false);
      if (isShowNotification) {
        setIsShowNotification(false);
      }
      if (SETTING_MENUS) {
        dispatch(showPopup({ name: 'showSetting', value: false }));
      }
    };
  }, [props.route]);

  const openCountryList = () => {
    if (isShowNotification) {
      setIsShowNotification(false);
    }
    if (showSetting) {
      dispatch(showPopup({ name: 'showSetting', value: false }));
    }
    setIsShowProfileDropdown(false);
    setIsShowLanguageDropdown(false);
    setIsShowCountryDropdown(isShowCountryDropdown ? false : true);
  };

  const openLanguageList = () => {
    if (isShowNotification) {
      setIsShowNotification(false);
    }
    if (showSetting) {
      dispatch(showPopup({ name: 'showSetting', value: false }));
    }
    setIsShowProfileDropdown(false);
    setIsShowCountryDropdown(false);
    setIsShowLanguageDropdown(isShowLanguageDropdown ? false : true);
  };

  const switchLanguage = (code) => {
    dispatch(changeLanguage(code));
    setIsShowLanguageDropdown(false);
  };

  const openProfile = () => {
    if (isShowNotification) {
      setIsShowNotification(false);
    }
    if (showSetting) {
      dispatch(showPopup({ name: 'showSetting', value: false }));
    }
    setIsShowCountryDropdown(false);
    setIsShowLanguageDropdown(false);
    setIsShowProfileDropdown(isShowProfileDropdown ? false : true);
  };

  const openSetting = () => {
    setIsShowProfileDropdown(false);
    setIsShowCountryDropdown(false);
    setIsShowLanguageDropdown(false);
    if (isShowNotification) {
      setIsShowNotification(false);
    }
    dispatch(
      showPopup({ name: 'showSetting', value: showSetting ? false : true }),
    );
  };

  const goToNotification = () => {
    setIsShowNotification(false);
    props.navigation.navigate('TaskNotificationNavigator', {
      screen: 'TaskNotificationScreen',
      params: { task: '' },
    });
  };

  const goToNotificationDetail = (item) => {
    setIsShowNotification(false);
    handleTaskNotificationDetail({ data: item, navigation: props.navigation });
    // if (item.target.entity === 'orders' && item.target.id) {
    //   const params = {
    //     id: item.target.id,
    //   };
    //   if (item?.object?.orderId) {
    //     params.titleScreen = item.object.orderId;
    //   }
    //   props.navigation.navigate('SalesOrderNavigator', {
    //     screen: 'SalesOrderDetailScreen',
    //     params: params,
    //   });
    // } else if (item.target.entity?.indexOf('target-settings') > -1 && item.target.id) {
    //   let temp_target_setting = item.target.entity;
    //   temp_target_setting = temp_target_setting.replace('target-settings', '');
    //   let type = '';
    //   let target_type = '';
    //   let title = '';
    //   let level = 'Level';

    //   if (temp_target_setting?.indexOf('-mt') > -1) {
    //     level = 'MT';
    //   } else if (temp_target_setting?.indexOf('-gt') > -1) {
    //     level = 'GT';
    //   }

    //   if (temp_target_setting?.indexOf('sales-value') > -1) {
    //     type = 'sales-value';
    //     title = 'Sales Value';
    //   } else if (temp_target_setting?.indexOf('product-focus') > -1) {
    //     type = 'product-focus';
    //     title = 'Product Focus';
    //   } else {
    //     type = 'doors';
    //     title = 'DOORS';
    //   }

    //   if (temp_target_setting?.indexOf('national') > -1) {
    //     target_type = 'national';
    //     title += ` - National ${level}`;
    //   } else if (temp_target_setting?.indexOf('channel') > -1) {
    //     target_type = 'channel';
    //     title += ` - Channel ${level}`;
    //   } else if (temp_target_setting?.indexOf('branch') > -1) {
    //     target_type = 'branch';
    //     title += ` - Branch ${level}`;
    //   } else if (temp_target_setting?.indexOf('salesman') > -1) {
    //     target_type = 'salesman';
    //     title += ` - Salesman ${level}`;
    //   }

    //   const params = {
    //     type: type,
    //     targetType: target_type,
    //     targetId: item.target.id,
    //     targetName: title,
    //     targetYear: item?.object?.year,
    //     title: title,
    //   };

    //   props.navigation.navigate('TargetSettingNavigator', {
    //     screen: 'TargetSettingApprovalScreen',
    //     params: params,
    //   });
    // } else {
    //   props.navigation.navigate('TaskNotificationNavigator', {
    //     screen: 'TaskNotificationDetailScreen',
    //     params: {
    //       titleScreen: item.title ? item.title : '',
    //       name: item.title ? item.title : '',
    //       id: item._id,
    //       isTask: '',
    //     },
    //   });
    // }
  };

  const openNotification = () => {
    setIsShowProfileDropdown(false);
    setIsShowCountryDropdown(false);
    setIsShowLanguageDropdown(false);
    if (showSetting) {
      dispatch(showPopup({ name: 'showSetting', value: false }));
    }
    if (isWeb) {
      getNotificationData();
      setIsShowNotification(isShowNotification ? false : true);
    } else {
      resetNotificationCount();
      goToNotification();
    }
  };

  const onClickSetting = (item) => {
    dispatch(showPopup({ name: 'showSetting', value: false }));
    if (item.stack_screen) {
      props.navigation.navigate(item.screen, {
        screen: item.stack_screen,
      });
    } else {
      props.navigation.navigate(item.screen);
    }
  };

  // setting menu list dropdown
  const SettingDropdown = () => {
    const userRole = userData?.role?.code || '';
    const menus = SETTING_MENUS.filter((menu) => {
      if (
        menu.hiddenForRoles?.length &&
        menu.hiddenForRoles.includes(userRole)
      ) {
        return false;
      }
      if (menu.permissions?.length) {
        return Boolean(
          menu.permissions.findIndex((p) => menuPermission.indexOf(p) > -1) >
            -1,
        );
      }
      return true;
    });
    return (
      <SettingList
        menus={menus}
        dispatch={dispatch}
        onClickSetting={onClickSetting}
      />
    );
  };

  const goToProfile = () => {
    props.navigation.dispatch(
      CommonActions.setParams({
        id: '',
        name: '',
        titleScreen: '',
        branchId: '',
        branchName: '',
      }),
    );
    props.navigation.navigate('ProfileNavigator', {
      screen: 'ProfileScreen',
      params: {
        id: '',
        name: '',
        titleScreen: '',
        branchId: '',
        branchName: '',
      },
    });
  };

  // callback when clicking button on profile dropdown
  const onClickDropdown = (type) => {
    if (type == 'profile') {
      goToProfile();
    } else {
      try {
        logEvent({
          eventName: 'logout_process',
          data: {
            method: isNative ? 'apps' : 'web',
          },
          dataKey: 'detail',
        });
        dispatch(Auth.logout());
        Toast.show({
          text1: 'You have successfully logged out',
          type: 'success',
        });
      } catch (err) {
        Toast.show({ text1: 'A system error occurred.', type: 'error' });
      }
    }
  };

  const checkCountry = async () => {
    const result = await isVn();
    setIsVietnam(result);
  };

  useEffect(() => {
    const isMounted = true;
    if (isMounted) {
      checkCountry();
    }
  }, []);

  const switchCountry = async (type) => {
    const coun = type == 'VN' ? 'b2b_vn' : 'b2b';
    if (!(userData?.is_active_for || []).includes(coun)) {
      dispatch(
        showAlert({
          show: true,
          title: 'Invalid Country',
          description: 'You cannot switch country',
          isConfirm: false,
          testID: 'header-country-switch',
          onCallback: () => {
            dispatch(showPopup({ name: 'changeCountry', value: false }));
          },
        }),
      );
      return;
    }
    await setCountryCookieAndRedirect(type, dispatch);
    checkCountry();
    setIsShowCountryDropdown(false);
  };

  const countryOptions = useMemo(() => {
    const countryList = userData?.is_active_for?.length
      ? userData?.is_active_for?.reduce((acc, val) => {
          const countryMap = {
            b2b_vn: { name: 'Vietnam', value: 'VN' },
            b2b: { name: 'Indonesia', value: 'ID' },
          };
          if (countryMap[val]) {
            acc.push(countryMap[val]);
          }
          return acc;
        }, [])
      : [
          { name: 'Indonesia', value: 'ID' },
          { name: 'Vietnam', value: 'VN' },
        ];

    return countryList.map((country) => ({
      key: country.value,
      label: country.name,
      testID: `header-country-option-${country.value.toLowerCase()}`,
      onSelect: () => switchCountry(country.value),
      icon: (
        <Image
          testID={`header-country-flag-${country.value.toLowerCase()}`}
          style={{ width: 16, height: 16, marginRight: 10 }}
          width={16}
          height={16}
          svg={true}
          source={
            country.value === 'ID'
              ? require('@/assets/img/icons/ID.svg')
              : require('@/assets/img/icons/VN.svg')
          }
        />
      ),
    }));
  }, [userData]);

  const languageOptions = useMemo(
    () =>
      VISIBLE_LANGUAGES.map((lang) => ({
        key: lang.code,
        label: lang.label,
        testID: `header-language-option-${lang.code}`,
        disabled: !lang.enabled,
        onSelect: () => switchLanguage(lang.code),
        icon: <RadioIcon selected={lang.code === language} />,
      })),
    [language],
  );

  const ProfileDropdown = useMemo(() => {
    return (
      <View testID="header-profile-dropdown" style={styles.profileDropdown}>
        <TouchableOpacity
          testID="header-profile-option-my-profile"
          activeOpacity={0.9}
          onPress={() => onClickDropdown('profile')}
          style={[styles.dropdownItem, styles.dropdownItemBordered]}>
          <SociollaText style={styles.dropdownText}>My Profile</SociollaText>
        </TouchableOpacity>
        <TouchableOpacity
          testID="header-profile-option-logout"
          activeOpacity={0.9}
          onPress={() => onClickDropdown('logout')}
          style={styles.dropdownItem}>
          <SociollaText style={styles.dropdownText}>Log out</SociollaText>
        </TouchableOpacity>
      </View>
    );
  }, []);

  // notification list dropdown
  const NotificationDropdown = () => {
    return (
      <View
        testID="header-notification-dropdown"
        style={[
          styles.profileDropdown,
          {
            minWidth: isWeb ? 300 : '100%',
            maxWidth: isWeb ? 300 : '100%',
            maxHeight: isWeb ? 350 : '100%',
          },
        ]}>
        <ScrollView>
          <NotificationList
            loading={isLoadingNotification}
            data={notifications}
            onDetail={goToNotificationDetail}
            onList={goToNotification}
          />
        </ScrollView>
      </View>
    );
  };

  const CountryInfo = useMemo(() => {
    return (
      <>
        <Image
          testID="header-country-flag"
          style={{ width: 16, height: 16, marginRight: 10 }}
          width={16}
          height={16}
          svg={true}
          source={
            isVietnam
              ? require('@/assets/img/icons/VN.svg')
              : require('@/assets/img/icons/ID.svg')
          }
        />
        <Text
          testID="header-country-name"
          style={styles.profileName}
          numberOfLines={1}>
          {isVietnam ? 'VN' : 'ID'}
        </Text>
      </>
    );
  }, [isVietnam]);

  const LanguageInfo = useMemo(() => {
    const currentLanguage =
      SUPPORTED_LANGUAGES.find((lang) => lang.code === language) ||
      SUPPORTED_LANGUAGES[0];
    return (
      <>
        <Image
          testID="header-language-globe"
          style={{ width: 16, height: 16, marginRight: 10 }}
          width={16}
          height={16}
          svg={true}
          source={require('@/assets/img/icons/globe-white.svg')}
        />
        <Text
          testID="header-language-name"
          style={styles.profileName}
          numberOfLines={1}>
          {currentLanguage.label}
        </Text>
      </>
    );
  }, [language]);

  const canViewGuideBook = menuPermission.indexOf('GuideBook') > -1;

  const goToGuideBook = () => {
    props.navigation.navigate('GuideBookNavigator', {
      screen: 'GuideBookScreen',
    });
  };

  const GuideBookSection = useMemo(() => {
    return canViewGuideBook ? (
      <TouchableOpacity
        testID="header-guide-book-btn"
        onPress={() => goToGuideBook()}
        style={[styles.profile, isWeb && styles.profileWeb]}
        activeOpacity={0.6}>
        <Image
          testID="header-guide-book-icon"
          source={require('@/assets/img/icons/guide-book-white.svg')}
          svg={true}
          style={{
            width: 18,
            height: 20,
            top: 2,
            left: 3,
            position: 'relative',
            marginRight: isWeb ? 8 : 0,
          }}
          width={18}
          height={20}
        />
        {isWeb ? (
          <SociollaText
            testID="header-guide-book-label"
            style={styles.profileName}>
            Guide Book
          </SociollaText>
        ) : (
          false
        )}
      </TouchableOpacity>
    ) : (
      false
    );
  }, [canViewGuideBook]);

  const CountrySection = useMemo(() => {
    return isWeb ? (
      <SwitcherDropdown
        testIDPrefix="header-country"
        buttonStyle={[styles.profile, isWeb && styles.profileWeb]}
        buttonContent={CountryInfo}
        arrowIcon={
          <Image
            source={require('@/assets/img/icons/arrow-down-white.svg')}
            style={{ width: 10, height: 5 }}
            width={10}
            height={5}
            svg={true}
          />
        }
        isOpen={isShowCountryDropdown}
        onToggle={openCountryList}
        options={countryOptions}
        dropdownStyle={styles.profileDropdown}
        optionStyle={[
          styles.dropdownItem,
          styles.dropdownItemBordered,
          styles.dropdownItemFlex,
        ]}
        optionTextStyle={styles.dropdownText}
      />
    ) : (
      false
    );
  }, [CountryInfo, isShowCountryDropdown, countryOptions]);

  const LanguageSection = useMemo(() => {
    return isWeb ? (
      <SwitcherDropdown
        testIDPrefix="header-language"
        buttonStyle={[styles.profile, isWeb && styles.profileWeb]}
        buttonContent={LanguageInfo}
        arrowIcon={
          <Image
            source={require('@/assets/img/icons/arrow-down-white.svg')}
            style={{ width: 10, height: 5 }}
            width={10}
            height={5}
            svg={true}
          />
        }
        isOpen={isShowLanguageDropdown}
        onToggle={openLanguageList}
        options={languageOptions}
        dropdownStyle={styles.profileDropdown}
        optionStyle={[
          styles.dropdownItem,
          styles.dropdownItemBordered,
          styles.dropdownItemFlex,
        ]}
        optionTextStyle={styles.dropdownText}
        disabledOptionTextStyle={[styles.dropdownText, { opacity: 0.4 }]}
      />
    ) : (
      false
    );
  }, [LanguageInfo, isShowLanguageDropdown, languageOptions]);

  const ProfileInfo = useMemo(() => {
    return (
      <>
        <Photo
          testID="header-profile-photo"
          image={userData.image}
          bordered
          borderWidth={2}
          width={photoWidth}
          height={photoWidth}
        />
        <Text
          testID="header-profile-name"
          style={styles.profileName}
          numberOfLines={1}>
          {userData.name ? userData.name : '-'}
        </Text>
      </>
    );
  }, [userData, photoWidth]);

  const ProfileSection = useMemo(() => {
    return isWeb ? (
      <TouchableOpacity
        testID="header-profile-btn"
        onPress={() => openProfile()}
        style={[styles.profile, isWeb && styles.profileWeb]}
        activeOpacity={isShowProfileDropdown ? 1 : 0.6}>
        {ProfileInfo}
        <Image
          source={require('@/assets/img/icons/arrow-down-white.svg')}
          style={{ width: 10, height: 5 }}
          width={10}
          height={5}
          svg={true}
        />
        {isShowProfileDropdown ? ProfileDropdown : false}
      </TouchableOpacity>
    ) : (
      false
    );
  }, [isShowProfileDropdown]);

  const NotificationTotal = useMemo(() => {
    return notificationCount ? (
      <View testID="header-notification-badge" style={{ position: 'relative' }}>
        <View
          style={{
            position: 'absolute',
            top: -23,
            right: isWeb && notificationCount > 99 ? 2 : 8,
            paddingVertical: 2,
            paddingHorizontal: 5,
            borderRadius: 10,
            backgroundColor: Colors.blue0,
            zIndex: 1,
            elevation: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <SociollaText
            type="medium"
            numberOfLines={1}
            style={{
              fontSize: 10,
              color: Colors.white,
              flexShrink: 1,
              ...(isWeb ? { overflowWrap: 'normal' } : {}),
            }}>
            {notificationCount > 99 ? '99+' : notificationCount}
          </SociollaText>
        </View>
      </View>
    ) : (
      false
    );
  }, [notificationCount]);

  const NotificationWrapper = useMemo(() => {
    return isShowNotification ? <NotificationDropdown /> : false;
  }, [isShowNotification, isLoadingNotification]);

  const SettingContent = useMemo(() => {
    return showSetting ? <SettingDropdown /> : false;
  }, [showSetting]);

  const SettingWrapper = useMemo(() => {
    if (disableSettingIcon) {
      return false;
    }
    return !isNative ? (
      <TouchableOpacity
        testID="header-settings-btn"
        onPress={() => openSetting()}
        style={styles.settingContainer}
        activeOpacity={showSetting ? 1 : 0.6}>
        <Image
          testID="header-settings-icon"
          key="settingStyle"
          width={nofiticationSize.width}
          height={nofiticationSize.height}
          style={{
            ...notificationStyle,
            ...nofiticationSize,
            marginLeft: 5,
          }}
          svg={true}
          source={require('@assets/img/icons/setting.svg')}
        />
        {SettingContent}
      </TouchableOpacity>
    ) : (
      false
    );
  }, [showSetting, nofiticationSize]);

  return (
    <View
      testID="header-wrapper"
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: isWeb ? 45 : 7,
      }}>
      {/* Guide Book Section */}
      {GuideBookSection}
      {isWeb && GuideBookSection ? <View style={styles.navSeparator} /> : null}
      {/* Language Section */}
      {LanguageSection}
      {isWeb && LanguageSection ? <View style={styles.navSeparator} /> : null}
      {/* Country Section */}
      {CountrySection}
      {isWeb && CountrySection ? <View style={styles.navSeparator} /> : null}
      {/* Profile Section */}
      {ProfileSection}
      {isWeb && ProfileSection ? <View style={styles.navSeparator} /> : null}
      {/* Notification Section */}
      <TouchableOpacity
        testID="header-notification-btn"
        onPress={() => openNotification()}
        activeOpacity={isShowNotification ? 1 : 0.6}>
        <Image
          testID="header-notification-icon"
          key="notificationStyle"
          width={nofiticationSize.width}
          height={nofiticationSize.height}
          style={{
            ...notificationStyle,
            ...nofiticationSize,
            marginRight: disableSettingIcon ? 0 : !isNative ? 15 : 0,
          }}
          svg={true}
          source={require('@assets/img/icons/notification.svg')}
        />
        {NotificationTotal}
        {NotificationWrapper}
      </TouchableOpacity>
      {/* Setting Section */}
      {
        // show setting menu for web or mobile web
        SettingWrapper
      }
    </View>
  );
};

const styles = StyleSheet.create({
  profile: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 20,
  },
  profileWeb: {
    marginRight: 0,
  },
  settingContainer: {
    position: 'relative',
  },
  profileName: {
    maxWidth: 180,
    fontSize: 13,
    fontFamily: 'figtree-regular',
    color: Colors.white,
    marginRight: 15,
  },
  profileDropdown: {
    position: 'absolute',
    right: 0,
    top: 37,
    width: 200,
    backgroundColor: Colors.white,
    borderRadius: 4,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  dropdownItem: {
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  dropdownItemBordered: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  dropdownItemFlex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dropdownText: {
    fontSize: 13,
    fontFamily: 'figtree-regular',
    color: Colors.darkblue0,
  },
  navSeparator: {
    width: 1,
    height: 24,
    marginHorizontal: 18,
    backgroundColor: 'rgba(255,255,255,0.5)',
  },
});

export default React.memo(
  NotificationSettingButton,
  (prev, next) => prev == next,
);
